import { useEffect, useState } from "react";

export default function CustomCursor() {
    const [pos, setPos] = useState({ x: -100, y: -100 });
    const [hovered, setHovered] = useState(false);
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        const isFine = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
        setEnabled(isFine);
        if (!isFine) return;

        const move = (e) => setPos({ x: e.clientX, y: e.clientY });
        const over = (e) => {
            const t = e.target;
            if (
                t?.closest?.("a, button, [role='button'], input, textarea, select, [data-cursor='pointer']")
            ) {
                setHovered(true);
            } else {
                setHovered(false);
            }
        };
        window.addEventListener("mousemove", move);
        window.addEventListener("mouseover", over);
        return () => {
            window.removeEventListener("mousemove", move);
            window.removeEventListener("mouseover", over);
        };
    }, []);

    if (!enabled) return null;
    return (
        <>
            <div className="aura-cursor-dot" style={{ left: pos.x, top: pos.y }} />
            <div
                className={`aura-cursor-ring ${hovered ? "hovered" : ""}`}
                style={{ left: pos.x, top: pos.y }}
            />
        </>
    );
}

